import { useAppDispatch, useAppSelector } from "app/store";
import {
  setSelectedDocumentId,
  setSource,
  setSplitPanelOpen as setFilePreviewOpen,
} from "components/file-preview-split-panel/slice";
import {
  setSelectedActivity,
  setSplitPanelOpen as setActivityLogOpen,
} from "features/activity-log-split-panel/slice";
import { closeProgressUpdate, openProgressUpdate } from "./slice";
import {
  IProgressUpdateSplitPanelState,
  ProgressUpdateCategory,
} from "./definitions";

export const useProgressUpdateSplitPanel = () => {
  const dispatch = useAppDispatch();
  const splitPanel = useAppSelector(
    (state) => state.progressUpdateSplitPanel as IProgressUpdateSplitPanelState,
  );

  return {
    splitPanel,
    open: (category: ProgressUpdateCategory) => {
      dispatch(setFilePreviewOpen(false));
      dispatch(setSelectedDocumentId(null));
      dispatch(setSource(null));
      dispatch(setActivityLogOpen(false));
      dispatch(setSelectedActivity(null));
      dispatch(openProgressUpdate(category));
    },
    close: () => {
      dispatch(closeProgressUpdate());
    },
  };
};
